<template>
  <div class="pos-app-wrapper flex flex-col fixed w-screen h-screen">
    <!--<Offline></Offline>-->
    <router-view/>
    <Ajax></Ajax>
    <v-dialog :min-width="600" :width="600" :min-height="400"/>
  </div>
</template>
<script>
  import { mapGetters } from 'vuex'
  import Ajax from '@/components/General/Ajax'
  import Offline from '@/components/General/Offline'
  import * as CONSTANTS from '@/store/constants.js'
  import ApiService from '@/common/api.service.js'
  export default {
    components: {
      Ajax, Offline
    },
    computed: {
      ...mapGetters('general', {
        ambient: 'ambient'
      }),
    },
    watch: {
      ambient: function(ambient) {
        this.setAmbient(ambient)
      }
    },
    methods: {
      setAmbient (ambient) {
        let el = document.getElementsByTagName("body")[0]
        if(ambient == CONSTANTS.AMBIENT_LIGHT) {
          el.classList.add('light')
          el.classList.remove('dark')
        } else {
          el.classList.add('dark')
          el.classList.remove('light')
        }
      }
    },
    mounted() {
      this.setAmbient(this.ambient)
    }
  }
</script>
